import { useMemo } from 'react';

import type {
	UsePageIncludeMacroParamsProps,
	UsePageIncludeMacroParamsResult,
} from '../pageIncludeMacroTypes.ts';
import { parseMacroTarget } from '../util/pageIncludeMacroParams.ts';

type MacroAdfNode = {
	attrs?: {
		localId?: string;
		parameters?: {
			macroMetadata?: {
				macroId?: {
					value?: string;
				};
			};
		};
	};
};

/**
 * Processes macro props and params into structured values for the renderer component.
 * Handles macro parameter parsing only — GraphQL query target selection and fetching are separate.
 */
export const usePageIncludeMacroParams = ({
	macroDefaultProps,
	macroParams,
}: UsePageIncludeMacroParamsProps): UsePageIncludeMacroParamsResult => {
	const parsedTarget = useMemo(() => parseMacroTarget(macroParams), [macroParams]);
	const macroNode = macroDefaultProps.node as MacroAdfNode | undefined;
	// Match the TOC walker's heading-id prefix.
	const macroId =
		macroNode?.attrs?.parameters?.macroMetadata?.macroId?.value ??
		macroNode?.attrs?.localId ??
		macroDefaultProps.attributes?.macroId ??
		undefined;
	const hostContentId: string = macroDefaultProps.contentId ?? '';

	return {
		parsedTarget,
		macroId: macroId ? `${macroId}` : undefined,
		hostContentId,
	};
};
